import { Area } from '@app/domain/Area'
import { Booking } from '@app/domain/Booking'
import { BookingStatus, BookingStatusType } from '@app/domain/BookingStatus'
import { Component, Input, OnInit } from '@angular/core'
import { DateTime } from 'luxon'
import { environment } from '../../../../../environments/environment'
import { Venue } from '@app/domain/Venue'

@Component({
    selector: 'app-booking-list-item',
    templateUrl: './booking-list-item.component.html',
})
export class BookingListItemComponent implements OnInit {

    @Input() booking!: Booking
    @Input() venue!: Venue
    @Input() area?: Area
    @Input() showDate = false
    @Input() showLocation = false
    @Input() showDetails = false

    partySizePluralMapping = {
        '=0': 'No covers',
        '=1': '1 cover',
        other: '# covers',
    }

    constructor() { }

    ngOnInit() { }

    protected readonly BookingStatus = BookingStatus
    protected readonly BookingStatusType = BookingStatusType
    protected readonly DateTime = DateTime
    protected readonly environment = environment
}
